import Button from '@/components/atoms/Button';
import { useLog } from '@/hooks/V3/useLog';
import useCopy from '@/hooks/useCopy';
import { RootState, useAppSelector } from '@/redux/store';
import { deviceUuidState } from '@/store/atom';
import { Message, ProductName } from '@/types/discover';
import { useRecoilValue } from 'recoil';

interface BubbleActionsProps {
  data: Message;
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  productNameList: Array<ProductName>;
  isLatest: boolean;
}

const BubbleActions = ({
  data,
  setMessages,
  setIsLoading,
  productNameList,
  isLatest,
}: BubbleActionsProps) => {
  const { copyToClipboard } = useCopy({
    toastMessage: '상품명이 복사됐어요',
  });

  const remainCount = data.remainCount || 0;
  const activeIndex = 5 - remainCount;
  const user = useAppSelector((state: RootState) => state.user);
  const { setUserEventHistory } = useLog(user.UserNo);
  const deviceUuid = useRecoilValue(deviceUuidState);

  const handleMakeAgain = () => {
    setIsLoading(true);
    setTimeout(() => {
      const botMessage: Message = {
        id: Date.now() + 1,
        text: productNameList[activeIndex].product_name,
        sender: 'bot',
        subText: productNameList[activeIndex].Consideration,
        list: productNameList[activeIndex].Keywords,
        remainCount: remainCount - 1,
      };
      setMessages((prevMessages) => [...prevMessages, botMessage]);
      setIsLoading(false);
    }, 2000);

    setUserEventHistory({
      eventName: 'ai_product_name_again',
      eventValue: productNameList[activeIndex].product_name,
      deviceUuid,
    });
  };

  return (
    <div className="flex items-center gap-[8px]">
      {data.id !== 0 && (
        <Button
          variant={'outline'}
          className="px-[18px] text-gr-700 Body4S14"
          onClick={() => {
            copyToClipboard(data.text);

            setUserEventHistory({
              eventName: 'copy_product_name',
              eventValue: data.text,
              deviceUuid,
            });
          }}
        >
          상품명 복사
        </Button>
      )}
      {productNameList.length > 0 && remainCount > 0 && isLatest && (
        <Button
          variant={'outline'}
          className="px-[18px] text-gr-700 Body4S14"
          onClick={handleMakeAgain}
        >
          다시 만들기 <span className="ml-1 text-point-500">{activeIndex}</span>/5
        </Button>
      )}
    </div>
  );
};

export default BubbleActions;
